import wait from "./_shared/wait/wait"
import loadVychatAsync from "./loadVyChatAsync/loadVychatAsync";
import loadGTMAsync from "./loadGTMAsync/loadGTMAsync";

export default async function featureConfiguration(){
    return Promise.any([loadVychatAsync(), wait.forTimeout(5000)]).then(()=>{
        return loadGTMAsync();
    })
}